/**
 * Ежедневная «Битва с AI Claude Opus»: рейтинговое лобби, которое сервер
 * открывает на аккаунте ИИ (см. src/utils/aiPromo/*). Здесь — то, что нужно
 * клиенту: картинки, подписи и статусы промо-лобби из дескриптора.
 *
 * Картинки добавляются в public отдельно; пока файла нет, браузер просто
 * покажет alt — поэтому иконку везде выводим через <img>, а не через CSS url().
 */

export const AI_ICON_PATH = '/img/icons/ai.png';
export const AI_PROMO_IMAGE_PATH = '/img/other/ai_promo.jpg';

// Подпись метки ИИ (title иконки) и короткое описание для профиля
export const AI_PLAYER_TITLE = 'ИИ: Claude Opus 5.5 (Anthropic)';
export const AI_PLAYER_PROFILE_DESCRIPTION = 'Это Claude Opus 5.5 — языковая модель от Anthropic. '
  + 'Аккаунт играет полностью самостоятельно: ходы и сообщения в чате — решения самой модели.';

export const AI_MATCH_TITLE = 'Битва с AI Claude Opus';
// Название рядом с иконкой ИИ — на кнопке главного меню и на плашке в списке
// лобби: «AI» там уже показывает сама иконка
export const AI_MATCH_SHORT_TITLE = 'Битва с Claude Opus';

// Статусы промо-лобби в дескрипторе (aiPromo.status) и в /api/ai-promo/today
export const AI_PROMO_STATUSES = {
  WAITING: 'waiting',
  COUNTDOWN: 'countdown',
  STARTING: 'starting',
  GAME_STARTED: 'game_started',
  CANCELLED: 'cancelled',
};

// Как часто главное меню опрашивает состояние промо-лобби: пока лобби есть —
// чаще (меняется время старта и число игроков), без лобби — редко
export const AI_PROMO_POLL_ACTIVE_MS = 20 * 1000;
export const AI_PROMO_POLL_IDLE_MS = 60 * 1000;
